import isdlAccessInstance from './isdlAccessInstance';

// GET
//Get Facemap Data
// export const getFacemapData = async (id) => await getDebugFacemapData(id);
export const getFacemapData = async (id) => await isdlAccessInstance.facemapData.GetFacemapData(id);

const getDebugFacemapData = async (id) => {
    if(id === "face map"){
        return FaceMapData;
    }else if(id === "cth"){
        return CTHdata;
    }
}

const FaceMapData = {
    "id": "Face Map",
    "Description": "Standard FaceMap",
    "ClubTypes": [
        {
            "ClubType": "driver",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": ".375 Toe",
                    "y": 0.375,
                    "z": 0
                },
                {
                    "Name": ".375 Toe .2 Up",
                    "y": 0.375,
                    "z": 0.2
                },
                {
                    "Name": ".2 Up",
                    "y": 0,
                    "z": 0.2
                },
                {
                    "Name": ".375 Heel .2 Up",
                    "y": -0.375,
                    "z": 0.2
                },
                {
                    "Name": ".375 Heel",
                    "y": -0.375,
                    "z": 0
                },
                {
                    "Name": ".375 Heel .2 Down",
                    "y": -0.375,
                    "z": -0.2
                },
                {
                    "Name": ".2 Down",
                    "y": 0,
                    "z": -0.2
                },
                {
                    "Name": ".375 Toe .2 Down",
                    "y": 0.375,
                    "z": -0.2
                },
                {
                    "Name": ".4 Down",
                    "y": 0,
                    "z": -0.4
                },
                {
                    "Name": ".5 Down",
                    "y": 0,
                    "z": -0.5
                },
                {
                    "Name": ".4 Up",
                    "y": 0,
                    "z": 0.4
                },
                {
                    "Name": ".5 Up",
                    "y": 0,
                    "z": 0.5
                },
                {
                    "Name": ".75 Toe",
                    "y": 0.75,
                    "z": 0
                },
                {
                    "Name": ".75 Toe .4 Up",
                    "y": 0.75,
                    "z": 0.4
                },
                {
                    "Name": ".75 Heel .4 Up",
                    "y": -0.75,
                    "z": 0.4
                },
                {
                    "Name": ".75 Heel",
                    "y": -0.75,
                    "z": 0
                },
                {
                    "Name": ".75 Heel .4 Down",
                    "y": -0.75,
                    "z": -0.4
                },
                {
                    "Name": ".75 Toe .4 Down",
                    "y": 0.75,
                    "z": -0.4
                },
                {
                    "Name": "Toe",
                    "y": 1,
                    "z": 0
                },
                {
                    "Name": "Heel",
                    "y": -1,
                    "z": 0
                }
            ]
        },
        {
            "ClubType": "fairway wood",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": ".375 Toe",
                    "y": 0.375,
                    "z": 0
                },
                {
                    "Name": ".375 Toe .2 Up",
                    "y": 0.375,
                    "z": 0.2
                },
                {
                    "Name": ".2 Up",
                    "y": 0,
                    "z": 0.2
                },
                {
                    "Name": ".375 Heel .2 Up",
                    "y": -0.375,
                    "z": 0.2
                },
                {
                    "Name": ".375 Heel",
                    "y": -0.375,
                    "z": 0
                },
                {
                    "Name": ".375 Heel .2 Down",
                    "y": -0.375,
                    "z": -0.2
                },
                {
                    "Name": ".2 Down",
                    "y": 0,
                    "z": -0.2
                },
                {
                    "Name": ".375 Toe .2 Down",
                    "y": 0.375,
                    "z": -0.2
                },
                {
                    "Name": ".75 Toe",
                    "y": 0.75,
                    "z": 0
                },
                {
                    "Name": ".75 Toe .15 Up",
                    "y": 0.75,
                    "z": 0.15
                },
                {
                    "Name": ".75 Heel .15 Up",
                    "y": -0.75,
                    "z": 0.15
                },
                {
                    "Name": ".75 Heel",
                    "y": -0.75,
                    "z": 0
                },
                {
                    "Name": ".75 Heel .15 Down",
                    "y": -0.75,
                    "z": -0.15
                },
                {
                    "Name": ".75 Toe .15 Down",
                    "y": 0.75,
                    "z": -0.15
                }
            ]
        },
        {
            "ClubType": "hybrid",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": ".5 Toe",
                    "y": 0.5,
                    "z": 0
                },
                {
                    "Name": ".5 Toe .2 Up",
                    "y": 0.5,
                    "z": 0.2
                },
                {
                    "Name": ".2 Up",
                    "y": 0,
                    "z": 0.2
                },
                {
                    "Name": ".5 Heel .2 Up",
                    "y": -0.5,
                    "z": 0.2
                },
                {
                    "Name": ".5 Heel",
                    "y": -0.5,
                    "z": 0
                },
                {
                    "Name": ".5 Heel .2 Down",
                    "y": -0.5,
                    "z": -0.2
                },
                {
                    "Name": ".2 Down",
                    "y": 0,
                    "z": -0.2
                },
                {
                    "Name": ".5 Toe .2 Down",
                    "y": 0.5,
                    "z": -0.2
                }
            ]
        },
        {
            "ClubType": "iron",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": ".5 Toe",
                    "y": 0.5,
                    "z": 0
                },
                {
                    "Name": ".5 Toe .2 Up",
                    "y": 0.5,
                    "z": 0.2
                },
                {
                    "Name": ".2 Up",
                    "y": 0,
                    "z": 0.2
                },
                {
                    "Name": ".5 Heel .2 Up",
                    "y": -0.5,
                    "z": 0.2
                },
                {
                    "Name": ".5 Heel",
                    "y": -0.5,
                    "z": 0
                },
                {
                    "Name": ".5 Heel .2 Down",
                    "y": -0.5,
                    "z": -0.2
                },
                {
                    "Name": ".2 Down",
                    "y": 0,
                    "z": -0.2
                },
                {
                    "Name": ".5 Toe .2 Down",
                    "y": 0.5,
                    "z": -0.2
                }
            ]
        }
    ],
}

const CTHdata = {
    "id": "CTH",
    "Description": "Center, Toe, Heel",
    "ClubTypes": [
        {
            "ClubType": "driver",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": "Toe",
                    "y": 0.375,
                    "z": 0
                },
                {
                    "Name": "Heel",
                    "y": -0.375,
                    "z": 0
                }
            ]
        },
        {
            "ClubType": "fairway wood",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": "Toe",
                    "y": 0.375,
                    "z": 0
                },
                {
                    "Name": "Heel",
                    "y": -0.375,
                    "z": 0
                }
            ]
        },
        {
            "ClubType": "hybrid",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": "Toe",
                    "y": 0.5,
                    "z": 0
                },
                {
                    "Name": "Heel",
                    "y": -0.5,
                    "z": 0
                }
            ]
        },
        {
            "ClubType": "iron",
            "Locations": [
                {
                    "Name": "Center",
                    "y": 0,
                    "z": 0
                },
                {
                    "Name": "Toe",
                    "y": 0.5,
                    "z": 0
                },
                {
                    "Name": "Heel",
                    "y": -0.5,
                    "z": 0
                }
            ]
        }
    ],
}